module.exports = __webpack_public_path__ + "static/media/banner-phone-nl.3215f8e5.png";